import { render } from "./FinanceReports.vue?vue&type=template&id=22b69f8b&ts=true"
import script from "./FinanceReports.vue?vue&type=script&lang=ts"
export * from "./FinanceReports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__